import { IDiscordMessage } from "#api/discord";
import { Embed } from "./embed";
import { Markdown } from "./markdown";
import { Attachments } from "./attachments";

interface IProps {
  message: IDiscordMessage;
}

export function Message({ message }: IProps) {
  return (
    <li key={message.id} id={`message-${message.id}`}>
      <Markdown text={message.content} />

      {message.embeds.map(embed => (
        <Embed embed={embed} />
      ))}

      <Attachments attachments={message.attachments} />
    </li>
  );
}
